// extracted by mini-css-extract-plugin
export default {"light-text-color":"rgb(105, 111, 119)","disclaimerSection":"styles_disclaimerSection__8vfDI","disclaimerText":"styles_disclaimerText__vAVLi"};